import type { McpSearchScope } from "./types";

export type SearchScopeCounts = {
  serverCount: number;
  toolCount: number;
  unoptimizedServerCount?: number;
  unoptimizedToolCount?: number;
};

/**
 * The tab to auto-select from result counts (ignoring any manual pin): the
 * Tools tab only when tools match and no servers do; otherwise the MCP servers
 * tab (when both match, only servers match, or nothing matches). Honoring a
 * user's manual pin is {@link resolveSearchScope}'s job.
 */
export function pickAutoSearchScope(counts: SearchScopeCounts): McpSearchScope {
  const {
    serverCount,
    toolCount,
    unoptimizedServerCount = 0,
    unoptimizedToolCount = 0,
  } = counts;
  const serversVisible = serverCount + unoptimizedServerCount;
  const toolsVisible = toolCount + unoptimizedToolCount;

  return toolsVisible > 0 && serversVisible === 0 ? "tools" : "servers";
}

export function isNewSearchSession(
  previousQuery: string,
  nextQuery: string
): boolean {
  const prevHasSearch = previousQuery.trim() !== "";
  const nextHasSearch = nextQuery.trim() !== "";
  return (!prevHasSearch && nextHasSearch) || (prevHasSearch && !nextHasSearch);
}

/**
 * The scope tab to show: the server grid when idle, otherwise the user's
 * manually pinned tab, falling back to the auto-picked tab.
 */
export function resolveSearchScope({
  hasSearch,
  pinnedScope,
  autoScope,
}: {
  hasSearch: boolean;
  pinnedScope: McpSearchScope | null;
  autoScope: McpSearchScope;
}): McpSearchScope {
  if (!hasSearch) {
    return "servers";
  }
  return pinnedScope ?? autoScope;
}
